import React from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { path, equals } from "ramda";
import { ReducerKeys } from "../../reducers";
import { Row,Col,Card } from "antd";
import I18n from "../../i18n/";
import { Colors, Metrics } from "../../theme";
import Chart from "../../components/chart/index";
import GraphCard from "../../components/report/GraphCard";
import GraphConstant from "../../constants/graph";
import { TargetValueType, LoadingKey, CompareCol } from "./CompareValuePanel";
import { BreadcrumbPath } from "../../components/navigation/OBreadcrumb";
import { MathUtil, isFunction, isAlive, ArrayUtil, isFillAlive } from "../../util";
import { ContainerLoading, PreloadDiv } from "../../components/loading/PersistGateLoading";
import OrgUtil from "../../util/organize";
import { ColorSelection } from "../../components/button/ColorButton";
import { GraphProvider } from "../../components/report/GenericGraphDrawer";

class ReportGenericPanel extends React.Component{
    state = {
    	loading: LoadingKey.Main,
    }
    views = {
    	viewMain: null,
    	mainValue:{},
    	detailValue:undefined,
    }

    texts = {}
    breadcrumbPath = [{text:"empty"}];

    spawnRenderCounter = 0;
    _onSelectLoaded = undefined;

    constructor(props){
    	super(props);
    	const { setRef } = props;
    	if(isFunction(setRef)){
    		setRef(this);
    	}
    	this.texts = { counseling: I18n.t("counseling") };
    }
    componentDidMount(){
    	const { fetchMain, targetValueType } = this.props;
    	this.updateMain(fetchMain(targetValueType), false);
    }
    updateMain(promise, errorOnInfo = true){
    	const { typeKey, getAutoSelectItem, onFetched, mainReadKey } = this.props;
    	this.views.viewMain = null;
    	this.views.mainValue = undefined;
    	this.views.detailValue = undefined;
    	this.setState({loading: LoadingKey.Main});
    	promise.then(res=>{
    		this.views.mainValue = res[mainReadKey];
    		if(isFillAlive(res[mainReadKey])){
    			if(onFetched){
    				onFetched(true, res[mainReadKey], false);
    			}
    			this.onMainClick(getAutoSelectItem(res[mainReadKey]), errorOnInfo, false);
    		}else{
    			if(onFetched){
    				onFetched(true, res[mainReadKey], true);
    			}
    			this.setState({loading:LoadingKey.None});
    		}
    	}).catch(error=>{
    		if(onFetched){
    			onFetched(true, undefined, true);
    		}
    		console.error(`fetchReport[${typeKey}].updateMain.error: `,error);
    		this.setState({
    			mainValue: {},
    			loading: LoadingKey.None,
    		});
    	});
    }
    onMainClick = (mainItem, errorOnInfo, loadingFirst = true)=>{
    	const { onMainValuePick, typeKey, fetchSelect, targetValueType, itemToPassSelect, onFetched } = this.props;
    	this.setBreadcrumbPath(mainItem, false);
    	this.views.detailValue = undefined;
    	const doQuery = ()=>{
    		const passValue = itemToPassSelect(mainItem);
    		if(isFunction(onMainValuePick)){
    			onMainValuePick(targetValueType,passValue);
    		}
    		fetchSelect(targetValueType, passValue, errorOnInfo).then((summary)=>{
    			this.views.viewMain = passValue;
    			this.views.detailValue = summary;
    			if(onFetched){
    				onFetched(false, summary, true);
    			}
    			this.setState({loading: LoadingKey.None});
    		}).catch(error=>{
    			if(onFetched){
    				onFetched(false, undefined, true);
    			}
    			//console.error(`fetchGeneric[${typeKey}].onMainClick.error: `,error);
    			this.setState({loading:LoadingKey.None});
    		});
    	};
    	if(loadingFirst){
    		this.setState({loading: LoadingKey.Detail}, doQuery);
    	}else{
    		doQuery();
    	}
    }
    setBreadcrumbPath(mainItem, update = true){
    	const { header, itemToBreadcrumbName } = this.props;
    	this.breadcrumbPath = [{text:this.texts.counseling}];
    	if(isAlive(mainItem)){
    		this.breadcrumbPath.push({text:header});
    		this.breadcrumbPath.push({text:itemToBreadcrumbName(mainItem)});
    	}
    	if(update){
    		this.forceUpdate();
    	}
    }
    shouldComponentUpdate(nextProps, nextState){
    	const { previousFetch, isVertical, targetValueType } = this.props;
    	const { loading } = this.state;
    	return (isVertical !== nextProps.isVertical) ||
            !equals(previousFetch, nextProps.previousFetch) ||
            (loading !== nextState.loading);
    }
    render(){
    	const { targetValueType, isVertical,
    		drawSingleGraph, drawListGraph,
    		typeKey, header, exclude = [], previousFetch, dateRange,
    		headKeys
    	} = this.props;
    	const DrawSingleGraph = drawSingleGraph;
    	const DrawListGraph = drawListGraph;
    	const { mainValue, detailValue, viewMain } = this.views;
    	const { loading } = this.state;
    	return <div>
    		<ContainerLoading isLoading={loading === LoadingKey.Main} 
    			loadingChildren={<PreloadDiv />}> 
    			<GraphProvider 
    				isVertical={isVertical} colorType={targetValueType}
    				showArrow={viewMain!==null} short={false} 
    				hilight={viewMain!==null}
    			>
    				<DrawSingleGraph 
    					header={header}
    					typeKey={typeKey} 
    					object={mainValue}
    					previousObject={previousFetch ? previousFetch.main : undefined}
    					isVertical={isVertical}
    					dateRange={dateRange}
    					colorType={targetValueType}
    					showLegend={true}
    					showValue={true}
    					onClick={this.onMainClick}
    					clickHeader={false}
    				/>
    			</GraphProvider>
    		</ContainerLoading>
    		<ContainerLoading isLoading={loading === LoadingKey.Detail} 
    			loadingChildren={<PreloadDiv />} />
    		{isAlive(detailValue) ? 
    			<div style={{marginTop:Metrics.button.bigSpaceMargin}}>
    				<BreadcrumbPath path={this.breadcrumbPath}/>
    				<DrawListGraph 
    					summary={detailValue}
    					previousSummary={previousFetch ? previousFetch.select : undefined}
    					colorType={targetValueType}
    					headKeys={headKeys}
    					isVertical={isVertical}
    					dateRange={dateRange}
    					single={isVertical}
    					showLegend={true}
    					exclude={exclude.concat(typeKey)}
    				/>
    			</div> : undefined }
    	</div>;
    }
}

function state2props(state){
	return { organization: path([ReducerKeys.ORGANIZATION, "organization"], state)};
}
const DefaultGraphDrawer = (props)=><div>Draw graph here</div>;

ReportGenericPanel.defaultProps = {
	drawSingleGraph:DefaultGraphDrawer,
	drawListGraph:DefaultGraphDrawer,
	itemToBreadcrumbName:(item)=>item.charAt(0).toUpperCase()+item.slice(1),
	getAutoSelectItem:(totalResponse)=>{
		const keys = Object.keys(totalResponse);
		if(keys.length > 0){
			return keys[0];
		}
		return null;
	},
	itemToPassSelect:(item)=>item.toLowerCase(),
	mainReadKey:"total",
};

ReportGenericPanel.propTypes = {
	typeKey:              PropTypes.string.isRequired,
	header:               PropTypes.string.isRequired,
	previousFetch:        PropTypes.object,
	fetchMain:            PropTypes.func.isRequired,
	fetchSelect:          PropTypes.func.isRequired,
	onMainValuePick:	  PropTypes.func,
	getAutoSelectItem:    PropTypes.func,
	itemToBreadcrumbName: PropTypes.func,
	itemToPassSelect:     PropTypes.func,
	onFetched:            PropTypes.func,
	exclude:              PropTypes.arrayOf(PropTypes.string),
	mainReadKey:          PropTypes.string,
};
export default ReportGenericPanel;
//export default connect(state2props)(CounGenericPanel);


// WEBPACK FOOTER //
// ./src/containers/ReportPanels/ReportGenericPanel.js